// Depends
import { route, group, subGroup, meta } from '@/helpers/routes'

import Create from './form/form'
import Index from './index/index'

const movingRoutes = [
  route('create', '/create', Create, meta('Adicionar Mudança', true, 'guest')),
  route('edit', '/:id/edit', Create, meta('Editar Mudança', true, 'guest')),
  route('index', '/index', Index, meta('Lista de Mudança', true, 'guest'))
]

export default [
  ...group('/app', [
    ...subGroup('/moving', movingRoutes)
  ])
]



// WEBPACK FOOTER //
// ./src/app/tenant/moving/routes.js